module.exports = __webpack_public_path__ + "img/part8.ca86d466.png";